

import template from '../../templates/changeLogs/ChangeLog.ejs';
import moment from 'moment';
import {consts as LogConsts} from 'newModels/change-log.js';

module.exports = Backbone.View.extend({
    tagName: 'tr',
    events: {},

    initialize(options) {
        this.options = {
            positions: options.positions,
            locations: options.locations,
            leaveTypes: options.leaveTypes
        };
        return this.model.fetchUser()
            .then(u => {
                this.user = u;
                return this.model.fetchCompany();
            })
            .then(c => {
                this.company = c;
                return this.render();
            });
    },

    convertCompanyType(type) {
        if (!type) {
            return type;
        }
        switch (type) {
            case '01': {
                return 'Individual – Resident who does not carry on business';
            }
            case '02': {
                return 'Self-employed or Business';
            }
            case '03': {
                return 'Partnership';
            }
            case '04': {
                return 'Private Company (Sdn Bhd)';
            }
            case '05': {
                return 'Hindu Joint Family';
            }
            case '06': {
                return 'Association';
            }
            case '07': {
                return 'Deceased Person\'s Estate';
            }
            case '08': {
                return 'Trust Body';
            }
            case '09': {
                return 'Unit/Real Property Trust';
            }
            case '10': {
                return 'Co-Operative Society';
            }
            case '11': {
                return 'Real Estate Investment Trust / Property Trust Fund';
            }
            case '12': {
                return 'Limited Liability Partnership';
            }
            case '13': {
                return 'Business Trust';
            }
            case '14': {
                return 'Labuan Entity';
            }
            default: {
                return type;
            }
        }
    },

    convertBankTransactionType(type) {
        if (!type) {
            return type;
        }
        switch (type) {
            case '20': {
                return 'Rentas';
            }
            case '30': {
                return 'IBG';
            }
            default: {
                return type;
            }
        }
    },

    convertCompanyLeavePolicy(policy) {
        if (!policy) {
            return policy;
        }
        switch (policy) {
            case '0': {
                return 'Earned all at once' +
                    ' (renews at the beginning of the year)';
            }
            case '1': {
                return 'Earned all at once' +
                    ' (renews on employee\'s join date)';
            }
            case '2': {
                return 'Earned throughout the year' +
                    ' (renews at the beginning of the year)';
            }
            case '3': {
                return 'Earned throughout the year' +
                    ' (renews on employee\'s join date)';
            }
            default: {
                return policy;
            }
        }
    },

    convertCalculationType(type) {
        if (!type) {
            return type;
        }
        switch (type) {
            case '1': {
                return 'Fixed Number of Days';
            }
            case '2': {
                return 'All Days in Current Calendar Month';
            }
            case '3': {
                return 'Working Days in Current Calendar Month';
            }
            default: {
                return type;
            }
        }
    },

    convertWorkingDays(days) {
        if (!days) {
            return days;
        }
        const daysArray = JSON.parse(days);
        return `Sunday: ${daysArray[0]}, Monday: ${daysArray[1]},` +
            ` Tuesday: ${daysArray[2]}, Wednesday: ${daysArray[3]},` +
            ` Thursday: ${daysArray[4]}, Friday: ${daysArray[5]},` +
            ` Saturday: ${daysArray[6]}`;
    },



    getDescription() {
        switch (this.model.get('type')) {
            case 'company': {
                let oldValue = this.model.get('oldValue');
                let newValue = this.model.get('newValue');
                if (this.model.get('fieldName') === 'type') {
                    oldValue = this.convertCompanyType(
                        this.model.get('oldValue')
                    );
                    newValue = this.convertCompanyType(
                        this.model.get('newValue')
                    );
                } else if (
                    this.model.get('fieldName') === 'annualLeavePolicy'
                ) {
                    oldValue = this.convertCompanyLeavePolicy(
                        this.model.get('oldValue')
                    );
                    newValue = this.convertCompanyLeavePolicy(
                        this.model.get('newValue')
                    );
                } else if (
                    [
                        'prorateCalculationType',
                        'overtimeCalculationType',
                        'unpaidLeaveCalculationType'
                    ].includes(this.model.get('fieldName'))
                ) {
                    oldValue = this.convertCalculationType(
                        this.model.get('oldValue')
                    );
                    newValue = this.convertCalculationType(
                        this.model.get('newValue')
                    );
                } else if (this.model.get('fieldName') === 'workingDays') {
                    oldValue = this.convertWorkingDays(
                        this.model.get('oldValue')
                    );
                    newValue = this.convertWorkingDays(
                        this.model.get('newValue')
                    );
                }
                switch (this.model.get('operation')) {
                    case LogConsts.OPERATION_CREATE: {
                        return `Company ${this.company.get('companyName')}` +
                            ` was created`;
                    }
                    case LogConsts.OPERATION_UPDATE: {
                        return `Company ${this.company.get('companyName')}` +
                            ` ${this.model.get('fieldName')} changed from` +
                            ` ${oldValue || '-'} to` +
                            ` ${newValue || '-'}`;
                    }
                }
                break;
            }
            case 'employee':
                switch (this.model.get('operation')) {
                    case LogConsts.OPERATION_CREATE: {
                        return `Employee ${this.model.get('newValue')}` +
                            ` was created`;
                    }
                    case LogConsts.OPERATION_UPDATE: {
                        if (this.model.get('fieldName') === 'hiddenAt') {
                            if (
                                JSON.parse(this.model.get('newValue')) === ''
                            ) {
                                const time = moment(
                                    this.model.get('changeTime')
                                ).format('ddd MMM DD YYYY HH:mm:ss');
                                return `${this.model.get('employeeName')}` +
                                    ` was unarchived at ${time}`;
                            } else {
                                return `${this.model.get('employeeName')}` +
                                    ` was archived at` +
                                    ` ${this.model.get('newValue')}`;
                            }
                        } else {
                            let oldValue = this.model.get('oldValue');
                            let newValue = this.model.get('newValue');
                            let fieldName = this.model.get('fieldName');
                            if (this.model.get('fieldName') === 'positionId') {
                                if (oldValue) {
                                    fieldName = 'position';
                                    const position = this.options
                                        .positions.models.find(model => {
                                            return model.get('objectId') ===
                                                JSON.parse(oldValue);
                                        });
                                    oldValue = position.get('name');
                                }
                                if (newValue) {
                                    fieldName = 'position';
                                    const position = this.options
                                        .positions.models.find(model => {
                                            return model.get('objectId') ===
                                                JSON.parse(newValue);
                                        });
                                    newValue = position.get('name');
                                }
                            } else if (
                                this.model.get('fieldName') ===
                                    'companyLocationId'
                            ) {
                                if (oldValue) {
                                    fieldName = 'company location';
                                    const location = this.options
                                        .locations.models.find(model => {
                                            return model.get('objectId') ===
                                                JSON.parse(oldValue);
                                        });
                                    oldValue = location.get('name');
                                }
                                if (newValue) {
                                    fieldName = 'company location';
                                    const location = this.options
                                        .locations.models.find(model => {
                                            return model.get('objectId') ===
                                                JSON.parse(newValue);
                                        });
                                    newValue = location.get('name');
                                }
                            } else if (
                                this.model.get('fieldName') === 'daysEntitled' && this.model.get('descriptions')
                            ) {
                                return this.model.get('descriptions')
                            } 
                            return `${this.model.get('employeeName')}` +
                            ` ${fieldName} changed from` +
                            ` ${oldValue || '-'} to` +
                            ` ${newValue || '-'}`;
                        } 
                    }
                    case LogConsts.OPERATION_DELETE: {
                        return `Employee ${this.model.get('oldValue')}` +
                            ` was deleted`;
                    }
                }
                break;
            case 'bank account': {
                let oldValue = this.model.get('oldValue');
                let newValue = this.model.get('newValue');
                if (this.model.get('fieldName') === 'transactionType') {
                    oldValue = this.convertBankTransactionType(
                        this.model.get('oldValue')
                    );
                    newValue = this.convertBankTransactionType(
                        this.model.get('newValue')
                    );
                }
                switch (this.model.get('operation')) {
                    case LogConsts.OPERATION_UPDATE: {
                        if (!this.model.get('employeeName')) {
                            return `Company bank account ${
                                this.model.get('fieldName')
                            } changed from ${
                                oldValue || '-'
                            } to ${newValue || '-'}`;
                        } else {
                            return `${
                                this.model.get('employeeName')
                            } bank account ${
                                this.model.get('fieldName')
                            } changed from  ${oldValue || '-'} to ${
                                newValue || '-'
                            }`;
                        }
                    }
                }
                break;
            }
            case 'address':
                switch (this.model.get('operation')) {
                    case LogConsts.OPERATION_UPDATE: {
                        if (!this.model.get('employeeName')) {
                            return `Company address` +
                                ` ${this.model.get('fieldName')} changed from` +
                                ` ${this.model.get('oldValue') || '-'} to` +
                                ` ${this.model.get('newValue') || '-'}`;
                        } else {
                            return `${this.model.get('employeeName')} address` +
                                ` ${this.model.get('fieldName')} changed from` +
                                ` ${this.model.get('oldValue') || '-'} to` +
                                ` ${this.model.get('newValue') || '-'}`;
                        }
                    }
                }
                break;
            case 'ytd':
                const itemName = this.model.get('fieldName');
                const employeeName = this.model.get('employeeName') ||
                    this.model.get('employeeId');

                let description = `YTD item "${itemName}" for employee \
                    ${employeeName}`;
                if (this.model.get('oldValue')) {
                    const oldValue = this.model.get('oldValue');

                    description += `| old values: ${oldValue}`;
                }
                description += `| new values: ${this.model.get('newValue')}`;
                return description;
            case 'payroll': {
                if (this.model.get('fieldName') === 'revertedAt') {
                    return `Payroll for` +
                        ` ${this.model.get('oldValue')}` +
                        ` was reverted at ${this.model.get('newValue')}`;
                }
                if (this.model.get('descriptions')) {
                    return this.model.get('descriptions');
                }
                break;
            }
            default: {
                if (this.model.get('descriptions')) {
                    return this.model.get('descriptions');
                }
                return `${this.model.get('type')}: \
                    ${this.model.get('fieldName') || ''}
                    ${this.model.get('oldValue') ?
        this.model.get('oldValue') + '=>' : ''
}
                    ${this.model.get('newValue')}`;
            }
        }
    },

    render() {
        this.$el.html(template({
            model: this.model,
            description: this.getDescription(),
            company: this.company,
            moment: moment
        }));
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/changeLogs/ChangeLog.js